import { IApplicationState } from '../../types/redux';

export function getGALabel(state: IApplicationState) {
  const {
    newbuilding: { gaLabel },
  } = state;

  return gaLabel;
}
